/* Resolves runtime + build-time config into a single frozen object.
 *
 * Precedence (highest first):
 *   1. window.__REKRAFT_CONFIG__   ← public/config.js (per-environment swap)
 *   2. import.meta.env.VITE_*      ← .env at build time
 *   3. Hard-coded defaults below
 *
 * When `API_BASE_URL` is unset, the per-resource modules in src/api/
 * transparently fall back to in-memory mock data so the app stays usable.
 */

const runtime = (typeof window !== 'undefined' && window.__REKRAFT_CONFIG__) || {};

const env = import.meta.env;

function pick(runtimeKey, viteKey, fallback) {
  if (runtime[runtimeKey] !== undefined && runtime[runtimeKey] !== null && runtime[runtimeKey] !== '') {
    return runtime[runtimeKey];
  }
  if (env[viteKey] !== undefined && env[viteKey] !== '') return env[viteKey];
  return fallback;
}

export const config = Object.freeze({
  API_BASE_URL:       pick('API_BASE_URL',       'VITE_API_BASE_URL',       ''),
  PAYMENT_PUBLIC_KEY: pick('PAYMENT_PUBLIC_KEY', 'VITE_PAYMENT_PUBLIC_KEY', ''),
  PUSH_PUBLIC_KEY:    pick('PUSH_PUBLIC_KEY',    'VITE_PUSH_PUBLIC_KEY',    ''),
  SENTRY_DSN:         pick('SENTRY_DSN',         'VITE_SENTRY_DSN',         ''),
  ENV:                pick('ENV',                'MODE',                    env.MODE || 'development'),
  IS_DEV:             (env.MODE || 'development') === 'development',
  IS_MOCK:            !pick('API_BASE_URL', 'VITE_API_BASE_URL', ''),
});
